import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export function getCheckInTimelineApi({ checkInId, offset = 0, limit = 5 }) {
  const url = endpoints.checkIn.timeline(checkInId);
  return sendRequest({
    url,
    method: 'GET',
    queryParams: {
      offset,
      limit,
    },
    credentials: 'include',
  });
}

export function getCheckInQuestionsApi({ orgId, checkInId }) {
  const url = endpoints.checkIn.talkingPointQuestions(orgId);
  return sendRequest({
    url,
    method: 'GET',
    queryParams: { checkInId },
    credentials: 'include',
  });
}

export function getRecurrenceDetailsApi({ parentPostId }) {
  const url = endpoints.checkIn.recurrenceDetails;
  return sendRequest({
    url,
    method: 'GET',
    queryParams: { parentPostId },
    credentials: 'include',
  });
}

export function updateRecurrenceDetailsApi({ checkInId, recurrentTask, recurrenceType, startTS, dueTS }) {
  const url = endpoints.checkIn.recurrenceDetails;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: {
      id: checkInId,
      recurrentTask: { id: recurrentTask?.id },
      recurrenceType,
      startTS,
      dueTS,
    },
  });
}

export function getOneOnOnePreferencesApi() {
  const url = endpoints.checkIn.preferences;
  return sendRequest({
    url,
    credentials: 'include',
  });
}

export function createOneOnOnesApi({ requestList }) {
  const url = endpoints.checkIn.createOneOnOnes;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      oneOnOneList: requestList,
    },
  });
}

// new ones
export function getStatsForEmployeeApi({ employeeId }) {
  const url = endpoints.oneOnOne.stats;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      employeeId,
    },
  });
}

export function getOneOnOnesListApi({ employeeId, active = true }) {
  const url = endpoints.oneOnOne.list;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      employeeId,
      active,
    },
  });
}

export function getOneOnOneChartApi({ requestData }) {
  const url = endpoints.oneOnOne.chart;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: requestData,
  });
}

export function getOneOnOneInstancesListApi({ parentId, employeeId }) {
  const url = endpoints.oneOnOne.instanceList(parentId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      employeeId,
    },
  });
}

export function getOneOnOneGuideApi() {
  const url = endpoints.oneOnOne.guide;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
}

export function saveOneOnOnePreferencesApi({ recurrenceId, recurrentTaskId, templateId }) {
  const url = endpoints.oneOnOne.savePreference(recurrentTaskId);
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      templateId,
      recurrenceDetailsId: recurrenceId,
    },
  });
}

export function getTalkingPointContinuousCommentsApi({
  checkInId,
  offset = 0,
  limit = 10,
  scrollType,
  questionId,
  parentId,
  startTS,
  endTS,
}) {
  const url = endpoints.oneOnOne.comments;

  const queryParams = {
    instanceId: checkInId,
    offset,
    limit,
    scrollType,
    questionId,
    parentId,
  };

  if (startTS && endTS) {
    queryParams.startTS = startTS;
    queryParams.endTS = endTS;
  }

  return sendRequest({
    url,
    method: 'GET',
    queryParams,
    credentials: 'include',
  });
}
export function getDefaultOneOnOneTemplateApi({ orgId }) {
  const url = endpoints.oneOnOne.defaultTemplate(orgId);
  return sendRequest({
    url,
    credentials: 'include',
  });
}

export function putDefaultOneOnOneTemplateApi({ orgId, templateId }) {
  const url = endpoints.oneOnOne.defaultTemplate(orgId);
  return sendRequest({
    url,
    credentials: 'include',
    method: 'PUT',
    queryParams: {
      templateId,
    },
  });
}

export function archiveOneOnOneApi({ empId, managerId }) {
  const url = endpoints.checkIn.archiveOneOnOne;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      empId,
      managerId,
    },
  });
}

export function unarchiveOneOnOneApi({ empId, managerId }) {
  const url = endpoints.checkIn.unarchiveOneOnOne;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      empId,
      managerId,
    },
  });
}

export function getAllEmployeeFeedbacksApi({ limit, offset, empId }) {
  const url = endpoints.oneOnOne.feedback;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      emp_id: empId,
      limit,
      offset,
    },
  });
}
